import {ColorSchemeType} from 'platform/components';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {
  useChangeBusinessCaseLeadQualityMutation,
  useGetBusinessCaseQuery,
  useGetLeadQualityOptionsQuery,
} from '@dms/api/sales';
import {LeadQualityEnum} from '@dms/api/shared';
import {EntityHeaderDropdownFlag} from '@dms/shared';

import {buildArray, Nullish} from 'shared/web';

const getLeadQualityColorScheme = (value: string | Nullish) =>
  match<string | Nullish, ColorSchemeType>(value)
    .with('blue', always('blue'))
    .with('yellow', always('yellow'))
    .with('red', always('red'))
    .with('gray', always('neutral'))
    .otherwise(always('neutral'));

export function useBusinessCaseDropdownFlags(businessCaseId: string) {
  const {data: businessCase} = useGetBusinessCaseQuery({businessCaseId});
  const {data: leadQualityOptions} = useGetLeadQualityOptionsQuery();
  const [changeBusinessCaseLeadQuality] = useChangeBusinessCaseLeadQualityMutation();

  const onChangeBusinessCaseLeadQuality = (leadQuality: LeadQualityEnum) => {
    changeBusinessCaseLeadQuality({
      businessCaseId,
      changeLeadQualityRequestBody: {
        leadQuality,
      },
    });
  };

  const currentLeadQuality = leadQualityOptions?.find(
    (option) => option.value === businessCase?.leadQuality
  );

  const filteredOptions =
    leadQualityOptions?.filter((option) => option.value !== businessCase?.leadQuality) ?? [];

  return buildArray<EntityHeaderDropdownFlag>().add({
    label: currentLeadQuality?.label ?? '',
    colorScheme: getLeadQualityColorScheme(currentLeadQuality?.color),
    dropdownItems: filteredOptions.map((option) => ({
      label: option.label,
      onClick: () => {
        onChangeBusinessCaseLeadQuality(option.value as LeadQualityEnum);
      },
      flag: {
        label: option.label,
        colorScheme: getLeadQualityColorScheme(option?.color),
        isSubtle: false,
      },
    })),
  });
}
